<template>
    <div>
        <div style="position: relative; padding-bottom: 56.25%; height: 0;">
            <div
                    v-if="!src"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
                    :class="{'bg-dark': (!hover && !loading), 'bg-secondary': (hover || loading), 'mouse-hand': hover}"
                    @mouseover="hover = true"
                    @mouseout="hover = false"
                    @click="load"
            >
                <div v-if="loading" class="d-inline-block w-100 h-100 d-flex justify-content-center align-items-center">
                    <i class="fal fa-spin fa-spinner-third" style="font-size: 3rem"></i>
                </div>
                <div v-else-if="!error && valid" class="d-inline-block w-100 h-100 d-flex justify-content-center align-items-center">
                    <i class="fal fa-play-circle text-sf" style="font-size: 3rem"></i>
                </div>
                <div v-else  class="d-inline-block w-100 h-100 d-flex justify-content-center align-items-center">
                    <span>{{ error || 'Invalid video format' }}</span>
                </div>
            </div>
            <iframe v-if="src && !loading"
                    :src="src"
                    frameborder="0"
                    webkitallowfullscreen
                    mozallowfullscreen
                    allowfullscreen
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
            ></iframe>
        </div>
    </div>
</template>

<script>
  import ToastNotifications from "../shared/mixins/ToastNotifications";
  import Document from "../../models/Document";

  export default {
    name: 'VideoPreview',
    components: {},
    mixins: [ToastNotifications],
    props: {
      document: {
        default: function () {
          return null;
        }
      },
      cache: {
        default: function () {
          return true;
        }
      },
      autoload: {
        default: function () {
          return false;
        }
      },
    },
    data() {
      return {
        error: null,
        hover: false,
        valid: false,
        loading: false,
        src: null,
      };
    },
    watch: {
      document: {
        handler: function(curr, prev) {
          if(this.cache && prev && prev.id === curr.id) {
            return false;
          }
          this.error = null;
          this.valid = false;
          this.loading = false;
          this.src = null;
          if(this.document.mime_type.includes('video')) {
            this.valid = true;
          }
        },
        immediate: true
      },
    },
    methods: {
      load: function() {
        if(!this.valid) {
          return false;
        }
        this.loading = true;
        Document.api().file(this.document.id, this.document.mime_type, this.cache).then((response) => {
          let data = response.response.data;
          let type = this.document.mime_type;
          try {
            let file = new Blob([data], {type: type});
            let urlCreator = window.URL || window.webkitURL;
            this.src = urlCreator.createObjectURL(file);
          } catch (e) {
            this.error = 'Video could not load';
          }
          this.loading = false;
        }).catch(() => {
          this.error = 'Video could not load';
          this.loading = false;
        });
      }
    },
    mounted() {
      if(this.autoload && this.document) {
        this.load();
      }
    }
  }
</script>
<style>
    .mouse-hand {
        cursor: pointer;
        cursor: hand;
    }
</style>